import React from 'react';
import "../GuidedExperience/GuidedExperienceWizard.css";
import { useTranslation } from 'react-i18next';
import AIRPNumberInput from '../common/AIRPNumberInput/AIRPNumberInput';

interface ParkingRateWizardProps {
    totalPropertyNameFromThePreviousStep: string
    type: string;
    propertyName: string;
    parkings: Record<string, unknown>;
    setParkings: (value: Record<string, unknown>) => void;
}

export default function ParkingRateWizard(props: ParkingRateWizardProps): JSX.Element {
    const {totalPropertyNameFromThePreviousStep, type, propertyName, parkings, setParkings} = props;
    const { t } = useTranslation("guided_wizard");
    const currencySymbol = "$";

    return (<div className='multires-wizard-parking-rate'>
        <p>{t(`${type}-wizard.${type}-description-1`)}<b><u>{parkings[totalPropertyNameFromThePreviousStep] as number}</u></b>{t(`${type}-wizard.${type}-description-2`)}</p>
        <div className='max-width-small'>
        <AIRPNumberInput
            formatType="currency"
            textAlign='right'
            className='border'
            initialValue={parkings[propertyName] as number | null}
            name={propertyName}
            negatives={false}
            placeholder={"(" + currencySymbol + ")"} 
            onChange={(value: number | null) => {
                parkings[propertyName] = value
                setParkings({...parkings})
            }}/>
        </div>
    </div>)
}
